<template>
  <div>
    <q-modal
      :value="open"
      @hide="onClose()"
      id="details-modal"
      class="sl-modal"
      :maximized="maximized"
      :content-css="{width: '1200px', maxWidth: '100%', minHeight: '85vh'}"
    >
      <q-modal-layout>
        <q-toolbar slot="header">
          <q-toolbar-title >
            <q-icon :name="moduleIcon[module]"/>
            <span v-if="mode === 'add'">Add {{title}}</span>
            <span v-if="mode === 'edit'">Edit {{title}} Details</span>
          </q-toolbar-title>
          <slot name="header-options">
          </slot>
          <q-icon @click.native="toggleMaximized()" size="20px" class="gt-sm" name="filter_none" />
          <q-icon @click.native="onClose" name="clear" />
        </q-toolbar>   
        <user-details v-if="module === 'users'"/>
        <student-details v-if="module === 'students'"/>
        <course-details v-if="module === 'courses'"/>
        <class-details v-if="module === 'classes'"/>
        <order-details v-if="module === 'orders'"/>
      </q-modal-layout>
    </q-modal>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import UserDetails from '../User/UserDetails'
import StudentDetails from '../Student/StudentDetails'
import ClassDetails from '../Class/ClassDetails'
import CourseDetails from '../Course/CourseDetails'
import OrderDetails from '../Order/OrderDetails'

export default {
  name: 'DetailsModal',
  props: ['module'],
  components: {
    UserDetails,
    StudentDetails,
    CourseDetails,
    ClassDetails,
    OrderDetails
  },
  data () {
    return {
      moduleIcon: {
        users: 'user',
        students: 'users',
        classes: 'slideshare',
        courses: 'bookmark'
      },
      routeName: {
        users: 'User',
        students: 'Student',
        classes: 'Class',
        courses: 'Course',
        orders: 'Order'
      },
      maximized: false
    }
  },
  computed: {
    ...mapState({
      open: state => state.shared.detailsModal.open,
      mode: state => state.shared.detailsModal.mode
    }),
    title: function () { return this.routeName[this.$route.name.toLowerCase()] }
  },
  methods: {
    test (tab) {
    },
    ...mapMutations([
      'closeDetails'
    ]),
    onClose () {
      this.closeDetails()
    },
    toggleMaximized(){
      this.maximized = !this.maximized
    }
  }
}

</script>

<style lang="stylus">
  @import '~variables'
  .details-inner
    position absolute 
    height 100%
    width 100%
    .q-tabs-head
      z-index 2
      background-color lighten(border-color,80%) !important
      .q-tab.active
        border-bottom-color
        .q-tabs-bar 
          border-bottom-color $primary
        .q-tab-label
          color $primary
      .q-tab-label
        color text-color
    .sl-row.sl-abs
      height calc(100% - 60px)
      > .sl-col-12
        position absolute 
        top 50px
    .q-toolbar.sl-footer
      position absolute 
      bottom 0
      background white !important
      border-top 1px solid border-color
</style>
